/** Auto-generated by scripts/bump-client-version.mjs — do not edit by hand. */
export const BUILD_VERSION = '1.0.21';
